import FactWithDocumentDrawer from '@/components/molecules/FactWithDocumentDrawer';
import ChunkDrawer from '@/screens/Chronos/CaseEditor/CaseAssistant/Answer/components/ChunkDrawer';
import { useStore } from '@/store';

export const ReferenceDrawer = () => {
  const { referenceDrawer, closeReferenceDrawer } = useStore();

  // If we have a chunk ID, show the chunk drawer
  if (referenceDrawer.chunkId) {
    return (
      <ChunkDrawer
        caseId={referenceDrawer.caseId}
        chunkId={referenceDrawer.chunkId}
        isOpen={referenceDrawer.isOpen}
        onClose={closeReferenceDrawer}
      />
    );
  }

  return (
    <FactWithDocumentDrawer
      caseId={referenceDrawer.caseId}
      factId={referenceDrawer.factId}
      isOpen={referenceDrawer.isOpen}
      onClose={closeReferenceDrawer}
    />
  );
};
